import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { alphanumericValidator } from '../validatorFunctions';

@Directive({
  selector: '[gtAlphanumericValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: AlphanumericValidatorDirective, multi: true}]
})
export class AlphanumericValidatorDirective implements Validator {

  validate(control: AbstractControl): {[key: string]: any} | null {
    return alphanumericValidator()(control);
  }

}
